import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Divider, Form, Input, Select } from "antd";
import { doGetAllCategory, isSaving } from "stores/slices/category";
import { doGetWorkspacePage } from "stores/slices/workspace";

import ModalForm from "components/forms/components/modalForm";
import SelectMultiple from "components/inputs/selectSearchSingle";

import AppButton from "../../../components/button";
import { PATTERNS, USER_TYPE } from "../../../constants/appConstant";
import {
  doCreateMessageTemplate,
  doUpdateMessageTemplate,
} from "../../../stores/slices/messageTemplate";
import CategoryForm from "../category/categoryForm";

import styles from "../../../components/styles.module.scss";

const MessageTemplateForm = props => {
  const {
    isViewForm,
    userType,
    setLoadingList,
    loadingList,
    onCancel,
    messageTemplateSelected,
    onSuccess,
    onUpdate,
    broadcastMessage,
    workspaceId,
  } = props;
  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const categoryLoading = useSelector(isSaving);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [isView, setIsView] = useState(true);
  const [isRefresh, setIsRefresh] = useState(false);
  const { TextArea } = Input;

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [listAllCategory, setListAllCategory] = useState([]);
  const [isOpenCategoryForm, setIsOpenCategoryForm] = useState(false);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState();

  const fetchListCategory = async workspaceId => {
    if (userType === USER_TYPE.SUPER_ADMIN) {
      const request = {
        workspaceId:
          messageTemplateSelected && messageTemplateSelected?.workspaceId
            ? messageTemplateSelected?.workspaceId
            : workspaceId,
      };
      const { payload } = await dispatch(doGetAllCategory(request));
      if (payload && payload.status === 200) {
        const { data } = payload;
        const categoryList = data.map(category => {
          return {
            label: category.category,
            value: category.id,
          };
        });
        setListAllCategory([...categoryList]);
      }
    } else {
      const { payload } = await dispatch(doGetAllCategory());
      if (payload && payload.status === 200) {
        const { data } = payload;
        const categoryList = data.map(category => {
          return {
            label: category.category,
            value: category.id,
          };
        });
        setListAllCategory([...categoryList]);
      }
    }
  };

  useEffect(() => {
    if (userType === USER_TYPE.SUPER_ADMIN && !messageTemplateSelected) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
    if (userType !== USER_TYPE.SUPER_ADMIN) {
      fetchListCategory();
    }

    if (userType == USER_TYPE.USER && workspaceId) {
      setSelectedWorkspaceId(workspaceId);
    }
  }, []);

  const onFinish = async fieldsValue => {
    const params = {
      message: fieldsValue["message"]?.trim(),
      categoryId: fieldsValue["category"],
      title: fieldsValue["title"]?.trim(),
      tags: fieldsValue["tags"]?.join(","),
    };
    if (userType === USER_TYPE.SUPER_ADMIN) {
      params.workspaceId = fieldsValue["workspace"];
    }
    setLoading(true);

    if (messageTemplateSelected) {
      params.id = messageTemplateSelected.id;
      if (userType === USER_TYPE.SUPER_ADMIN) {
        params.workspaceId = fieldsValue["workspace"];
      }
      const { payload } = await dispatch(doUpdateMessageTemplate(params));
      if (payload && payload.status === 200) {
        setLoading(false);
        setIsRefresh(!isRefresh);
        onSuccess();
      } else {
        setLoading(false);
      }
    } else {
      const { payload } = await dispatch(doCreateMessageTemplate(params));
      if (payload && payload.status === 200) {
        setLoading(false);
        setIsRefresh(!isRefresh);
        onSuccess();
      } else {
        setLoading(false);
      }
    }
  };

  const validateMessages = {
    required: t("validate.required"),
  };

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  useEffect(() => {
    if (messageTemplateSelected) {
      setOptionWorkspace([
        {
          key: messageTemplateSelected.workspaceId,
          label: messageTemplateSelected.workspaceName,
        },
      ]);
    }
  }, [messageTemplateSelected]);

  const initialValue = messageTemplateSelected => {
    if (messageTemplateSelected) {
      if (userType === USER_TYPE.SUPER_ADMIN) {
        return {
          message: messageTemplateSelected.message,
          category: messageTemplateSelected.category?.id,
          title: messageTemplateSelected.title,
          tags: messageTemplateSelected?.tags?.split(","),
          workspace: messageTemplateSelected.workspaceId,
        };
      } else {
        return {
          message: messageTemplateSelected.message,
          category: messageTemplateSelected.category?.id,
          title: messageTemplateSelected.title,
          tags: messageTemplateSelected?.tags?.split(","),
        };
      }
    }
  };

  useEffect(() => {
    setIsView(isViewForm);
  }, [isViewForm]);

  useEffect(() => {
    if (broadcastMessage) {
      formRef.current.setFieldsValue({
        message: broadcastMessage,
      });
    }
  }, [broadcastMessage]);

  return (
    <div style={{ height: "100%" }}>
      <Form
        ref={formRef}
        initialValues={initialValue(messageTemplateSelected)}
        layout={"vertical"}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
      >
        {userType === USER_TYPE.SUPER_ADMIN && (
          <>
            <p
              className={styles.required}
              style={messageTemplateFormStyle.labelTitle}
            >
              {t("messageTemplates.workspace")}
            </p>
            <Form.Item name="workspace" rules={[{ required: true }]}>
              <SelectMultiple
                type={"select-search"}
                disabled={isView}
                loading={loadingList}
                showSearch
                allowClear={false}
                optionFilterProp="children"
                options={workspaceOption}
                onChange={value => {
                  formRef.current.setFieldsValue({
                    workspaceId: value,
                  });
                  setSelectedWorkspaceId(value);
                  if (userType === USER_TYPE.SUPER_ADMIN) {
                    fetchListCategory(value);
                  }
                }}
                config={{
                  width: "100%",
                }}
                handleSearch={handleSearchKeyWorkspace}
                handleScroll={handleScrollWorkspace}
              />
            </Form.Item>
          </>
        )}

        <p
          className={styles.required}
          style={messageTemplateFormStyle.labelTitle}
        >
          {t("messageTemplates.messageTitle")}
        </p>
        <Form.Item
          name="title"
          rules={[
            {
              required: true,
              message: t("validate.required"),
              transform(value) {
                if (value) {
                  return value.trim();
                }
              },
            },
            {
              pattern: new RegExp(PATTERNS.XSS_PATTERN),
              message: t("validate.noxss"),
            },
          ]}
        >
          <Input
            maxLength={45}
            disabled={isView}
            showCount
            count={{
              show: true,
              max: 45,
            }}
          />
        </Form.Item>

        <p
          className={styles.required}
          style={messageTemplateFormStyle.labelTitle}
        >
          {t("messageTemplates.message")}
        </p>
        <Form.Item
          name="message"
          rules={[
            {
              required: true,
              message: t("validate.required"),
              transform(value) {
                if (value) {
                  return value.trim();
                }
              },
            },
            {
              pattern: new RegExp(PATTERNS.XSS_PATTERN),
              message: t("validate.noxss"),
            },
          ]}
        >
          <TextArea
            style={{ height: 120 }}
            maxLength={5000}
            disabled={isView}
            showCount
            count={{
              max: 5000,
            }}
          />
        </Form.Item>

        <p
          className={styles.required}
          style={messageTemplateFormStyle.labelTitle}
        >
          {t("messageTemplates.category")}
        </p>
        <Form.Item
          name="category"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            loading={categoryLoading}
            disabled={isView}
            dropdownRender={menu => (
              <>
                {menu}
                <Divider
                  style={{
                    margin: "8px 0",
                  }}
                />
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <AppButton
                    label={`+ ${t("messageTemplates.addCategory")}`}
                    size={"medium"}
                    varient={"outlined"}
                    color={"primary"}
                    style={{
                      width: "100%",
                      minWidth: "auto",
                      border: "none",
                    }}
                    onClick={() => {
                      console.log("selectedWorkspaceId", selectedWorkspaceId);
                      if (!selectedWorkspaceId) {
                        toast.error("Must be select workspace first!");
                      } else {
                        setIsOpenCategoryForm(true);
                      }
                    }}
                  />
                </div>
              </>
            )}
            options={listAllCategory}
          />
        </Form.Item>

        <p style={messageTemplateFormStyle.labelTitle}>
          {t("messageTemplates.keywords")}
        </p>
        <Form.Item name="tags">
          <Select
            mode="tags"
            allowClear={true}
            notFoundContent={t("messageTemplates.pleaseInputKeywords")}
            disabled={isView}
          ></Select>
        </Form.Item>

        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "end",
            gap: "16px",
          }}
        >
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            htmlType="button"
            loading={loading}
            onClick={() => {
              onCancel();
            }}
          />
          {isView && (
            <AppButton
              label={t("button.edit")}
              color={"blue"}
              loading={loading}
              type="primary"
              htmlType="button"
              onClick={() => {
                onUpdate();
              }}
            />
          )}
          {!isView && (
            <AppButton
              label={
                messageTemplateSelected ? t("button.save") : t("button.create")
              }
              color={"blue"}
              type="primary"
              htmlType="submit"
              loading={loading}
            />
          )}
        </div>
      </Form>
      <ModalForm
        title={t("messageTemplates.addNewCategoryPopupTitle")}
        isOpen={isOpenCategoryForm}
        onCancel={() => setIsOpenCategoryForm(false)}
        footer={false}
        destroyOnClose={true}
        labelSubmit={t("label.save")}
        maskClosable={false}
      >
        <CategoryForm
          setIsOpenCategoryForm={setIsOpenCategoryForm}
          listAllCategory={listAllCategory}
          setListAllCategory={setListAllCategory}
          formTemplateRef={formRef}
          workspaceId={selectedWorkspaceId}
          isSuperAdmin={userType === USER_TYPE.SUPER_ADMIN}
        />
      </ModalForm>
    </div>
  );
};

const messageTemplateFormStyle = {
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  appearBox: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
};

export default MessageTemplateForm;
